import type { TTextLeaf } from './Text.types';

export const getTextColor = (text: TTextLeaf) => {
  const { marks } = text;

  //find the first mark that has a color attribute
  const color = marks?.find((mark) => mark.type === 'textStyle')?.attrs?.color;

  return color;
};
